import UserBoard from './UserBoard'

export default UserBoard



// WEBPACK FOOTER //
// ./src/components/UserBoard/index.js